import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useSubmitTagsNotes({
  documentKey,
  dataKey,
}: {
  documentKey: string
  dataKey: string | undefined
}) {
  const queryClient = useQueryClient()

  const { mutateAsync, isPending, isSuccess } = useMutation({
    ...apiClient.createDocumentTagsReviewDocumentsKeyTagsReviewsPostMutation(),
    onSuccess: () => {
      queryClient.invalidateQueries(
        apiClient.getDocumentTagsReviewsDocumentsKeyTagsReviewsGetOptions({
          path: { key: documentKey },
        }),
      )
    },
  })

  const submitTagsNotes = useCallback(
    async (notes: string) => {
      if (!dataKey) return
      await mutateAsync({
        path: { key: documentKey },
        body: {
          data_key: dataKey,
          is_valid: true,
          notes,
        },
      })
    },
    [mutateAsync, documentKey, dataKey],
  )

  return { submitTagsNotes, isPending, isSuccess }
}
